import React from 'react';
import BlogPreview from '../components/BlogPreview';
import { useSEO, SITE_URL } from '../hooks/useSEO';
import { blogPosts } from '../blog';

const BlogPage = () => {
  useSEO({
    title: 'GLB & glTF Optimization Blog – Guides & Tutorials',
    description: 'Practical guides to GLB and glTF: reducing file size, Draco and Meshopt compression, Blender export settings, three.js loading and 3D on Shopify.',
    canonical: '/blog',
    ogTitle: 'GLB & glTF Optimization Blog',
    ogDescription: 'Practical guides to making GLB and glTF files smaller and faster.',
    ogImage: '/images/og/blog.png',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      name: 'Compress GLB Blog',
      description: 'Guides and tutorials on GLB and glTF optimization and compression.',
      url: `${SITE_URL}/blog/`,
      blogPost: blogPosts.map((post) => ({
        '@type': 'BlogPosting',
        headline: post.title,
        url: `${SITE_URL}/blog/${post.slug}/`,
        datePublished: post.datePublished,
        dateModified: post.dateModified || post.datePublished,
      })),
    },
  });

  return (
    <>
      <h1 className="text-4xl font-bold text-foreground mb-4">GLB &amp; glTF optimization blog</h1>
      <p className="text-lg text-muted-foreground mb-12">
        Practical guides to making 3D models smaller and faster: file formats, compression, export settings and loading them on the web.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {blogPosts.map((post) => (
          <BlogPreview key={post.slug} post={post} />
        ))}
      </div>
    </>
  );
};

export default BlogPage;
